import { configure } from 'mobx';
import { checkIeBrowser } from 'src/utils/common';

const mobxPolyfill = () => {
  configure({
    useProxies: checkIeBrowser() ? 'never' : 'always',
  });
};

mobxPolyfill();
